document.addEventListener('DOMContentLoaded', function() {
    const searchForm = document.getElementById('blogSearchForm');
    const searchInput = document.getElementById('blogSearchInput');
    const searchButton = document.getElementById('blogSearchButton');
    const articlesContainer = document.getElementById('blogArticlesContainer');
    const noResultsMessage = document.getElementById('blogNoResults');

    // Esconder mensagem de "nenhum resultado" inicialmente
    if (noResultsMessage) {
        noResultsMessage.style.display = 'none';
    }

    if (searchForm && searchInput && articlesContainer) {
        // Função para remover acentos
        function removeAccents(text) {
            return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        }

        // Função para filtrar artigos com base no termo de busca
        function filterArticles() {
            const searchTermRaw = searchInput.value.trim().toLowerCase();
            const searchTerm = removeAccents(searchTermRaw);
            const articles = articlesContainer.querySelectorAll('.blog-articles__article');
            let resultsFound = false;

            if (searchTerm === '') {
                articles.forEach(article => {
                    article.style.display = '';
                });
                if (noResultsMessage) {
                    noResultsMessage.style.display = 'none';
                }
                return;
            }

            articles.forEach(article => {
                const title = removeAccents((article.getAttribute('data-article-title') || '').toLowerCase());
                const content = removeAccents((article.getAttribute('data-article-content') || '').toLowerCase());

                if (title.includes(searchTerm) || content.includes(searchTerm)) {
                    article.style.display = '';
                    resultsFound = true;
                } else {
                    article.style.display = 'none';
                }
            });

            if (noResultsMessage) {
                noResultsMessage.style.display = resultsFound ? 'none' : 'block';
            }
        }

        // Debounce opcional (evita chamadas em excesso ao digitar)
        let searchTimeout;
        function debounceFilter() {
            if (searchTimeout) {
                clearTimeout(searchTimeout);
            }
            searchTimeout = setTimeout(() => {
                filterArticles();
            }, 300);
        }

        // Event listeners
        searchButton.addEventListener('click', function(e) {
            e.preventDefault();
            filterArticles();
        });

        searchInput.addEventListener('keyup', function(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                filterArticles();
            } else {
                debounceFilter();
            }
        });
    }
});
